// =============================================================================
//  SCREEN: HelpScreen (Anleitung)
// =============================================================================
import React from 'react';

const HelpScreen = () => {
  return (
    <div className="screen-container">
      <div className="help-content">
        <h2>Kurzanleitung: So erstellst du dein Turnier!</h2>
        <p>
          Willkommen beim Kegel-Turnier-Manager! Mit diesem Tool hast du alles im Griff,
          von der ersten Idee bis zur finalen Siegerehrung. Hier ist eine Schritt-für-Schritt-Anleitung,
          wie du ein komplettes Turnier auf die Beine stellst.
        </p>

        <hr />

        <h3>Schritt 1: Das Turnier anlegen</h3>
        <p>
          Alles beginnt mit dem Fundament – deinem Turnier. Geh zur Seite <strong>"Turniere"</strong> und leg los.
        </p>
        <ul>
          <li><strong>Grunddaten:</strong> Gib deinem Turnier einen coolen Namen, wähle Start- und Enddatum und den Austragungsort.</li>
          <li><strong>Wertungen:</strong> Wähle alle Wertungen aus, die du anbieten möchtest (z.B. Herren, Damen, Mannschaft Mixed). Das ist wichtig für die spätere Sortierung der Ergebnisse.</li>
          <li>
            <strong>Startplan-Konfiguration (Das Herzstück):</strong> Hier definierst du, wann gespielt wird. Vergiss starre Zeitpläne! Mit den <strong>Zeitplan-Blöcken</strong> bist du super flexibel:
            <ul>
              <li>Klicke auf <strong>"+ Spieltag hinzufügen"</strong>.</li>
              <li>Wähle ein <strong>Datum</strong> aus, z.B. den 17.10.2025.</li>
              <li>Gib eine <strong>Start- und Endzeit</strong> für diesen Tag ein, z.B. 16:00 bis 21:00 Uhr.</li>
              <li>Lege das <strong>Intervall</strong> fest (z.B. 60 Min.), in dem neue Starts beginnen.</li>
              <li>Wiederhole das für jeden einzelnen Spieltag deines Turniers. So kannst du auch komplizierte Pläne (Wochenenden länger, unter der Woche kürzer) perfekt abbilden.</li>
            </ul>
          </li>
        </ul>

        <h3>Schritt 2: Nennungen verwalten – Wer ist am Start?</h3>
        <p>
          Nach dem Anlegen landest du auf der Detailseite des Turniers. Hier trägst du alle Teilnehmer ein.
        </p>
        <h4>Mannschaften anlegen:</h4>
        <p>
          Der schnellste Weg, Teams ins Spiel zu bringen.
        </p>
        <ul>
          <li>Gib den Mannschaftsnamen ein.</li>
          <li>Wähle die passende Mannschafts- und Einzelwertung für die Spieler dieses Teams.</li>
          <li>Trage die Namen der Spieler ein (Vor- und Nachname). Das System legt diese Spieler automatisch an. Du musst sie nicht vorher auf der "Spieler"-Seite erstellen!</li>
        </ul>
        <h4>Stammspieler nennen:</h4>
        <p>
          Für Einzelstarter oder um bestehende Mannschaften aufzufüllen.
        </p>
        <ul>
          <li>Wähle einen bereits im System erfassten Spieler (Stammspieler) aus der Liste.</li>
          <li>Gib ihm seine Einzel-Wertung.</li>
          <li>Optional: Weise ihn einem Team zu, das noch freie Plätze hat.</li>
        </ul>

        <h3>Schritt 3: Den Startplan erstellen (Drag & Drop!)</h3>
        <p>
          Geh über den Header-Link zum <strong>"Startplan"</strong>. Hier wird's interaktiv!
        </p>
        <ul>
          <li>Links siehst du die Kiste mit allen <strong>"Unplatzierten Nennungen"</strong>. Diese sind jetzt nach Mannschaften und Einzelstartern gruppiert.</li>
          <li>Rechts siehst du deinen Zeitplan, der automatisch aus deinen konfigurierten Zeitplan-Blöcken generiert wurde.</li>
          <li>Ziehe Einzelspieler wie gewohnt auf einen freien Slot.</li>
          <li>
            <strong>Ganze Mannschaften platzieren:</strong> Ziehe einen blauen Mannschafts-Block auf die gewünschte Startzeit und Startbahn. Das System platziert dann automatisch alle 4 Spieler nach dem festgelegten Bahnschema.
            <strong>Wichtig:</strong> Die Aktion wird nur ausgeführt, wenn alle 4 Ziel-Slots frei sind!
          </li>
        </ul>

        <h3>Schritt 4: Ergebnisse eintragen – Der digitale Wurfschein</h3>
        <ul>
          <li>Klicke im fertigen Startplan auf einen Spieler.</li>
          <li>Es öffnet sich das Ergebnisfenster. Die Bahnen sind bereits in der korrekten Reihenfolge (je nach Startbahn) sortiert.</li>
          <li>Trage die Ergebnisse für "Volle", "Abräumen" (Abr.) und "Fehlwürfe" (FW) ein. Das Gesamtergebnis pro Bahn und das Total werden automatisch berechnet.</li>
          <li>Du kannst auch Teilergebnisse speichern und später vervollständigen.</li>
        </ul>

        <h3>Schritt 5: Auswertungen & Präsentation</h3>
        <h4>Die Ergebnisliste:</h4>
        <p>
          Unter dem Link <strong>"Ergebnisse"</strong> findest du die immer aktuelle Rangliste.
        </p>
        <ul>
          <li>Alle Ergebnisse sind automatisch nach Wertung gruppiert und nach den Regeln sortiert.</li>
          <li>Mit dem Button <strong>"Gesamte Ergebnisliste als PDF"</strong> erstellst du ein professionelles Dokument für den Aushang.</li>
          <li>Mit dem kleinen Druck-Icon 🖨️ neben einer Wertung erstellst du ein PDF nur für diese eine Kategorie.</li>
        </ul>
        <h4>Die Streamer-Ansicht (für YouTube & Co.):</h4>
        <ul>
          <li>Klicke auf das TV-Icon 📺 neben einer Wertung.</li>
          <li>Es öffnet sich eine minimalistische Seite mit dieser einen Tabelle. Diese Seite hat einen transparenten Hintergrund und ist perfekt, um sie in einer Streaming-Software (z.B. OBS) oder deiner iFrame-Slideshow einzublenden.</li>
          <li>Das Beste: Die Daten auf dieser Seite <strong>aktualisieren sich alle 30 Sekunden von selbst!</strong></li>
        </ul>

        <h3>Schritt 6: Die Finanzen im Griff</h3>
        <p>
          Unter <strong>"Finanzen"</strong> verwaltest du alle Einnahmen.
        </p>
        <ul>
          <li><strong>Startgelder:</strong> Die Liste aller Teilnehmer wird automatisch erstellt. Trage in der Spalte "Bezahlt" einfach den Betrag ein, den eine Mannschaft oder ein Spieler gegeben hat.</li>
          <li><strong>Sponsoren & Spenden:</strong> Füge einzelne Sponsoren oder Spender mit Namen und Betrag hinzu.</li>
          <li><strong>Kantine:</strong> Erfasse die Tageseinnahmen der Kantine.</li>
          <li>Die <strong>Gesamtsumme</strong> wird dir immer live angezeigt. Jede Änderung wird mit dem "Speichern"-Button gesichert.</li>
        </ul>
        
        <h3>Schritt 7: Die Statistik für Nerds</h3>
        <p>
          Wolltest du schon immer wissen, ob Bahn 3 wirklich "schlechter" ist als Bahn 1? Geh auf <strong>"Statistik"</strong>.
        </p>
        <ul>
          <li>Hier siehst du ein Säulendiagramm, das die Leistungen pro Bahn vergleicht.</li>
          <li>Mit den Filtern kannst du genau auswählen, was dich interessiert: Nur die Damen? Nur die Fehlwürfe? Der Durchschnitt pro Start? Alles ist möglich.</li>
        </ul>

        <h3>Tipps & Tricks für Profis</h3>
        <h4>Mannschaften einklappen:</h4>
        <p>
          Wird die Liste der Mannschaften in der Nennungs-Übersicht zu lang? Klicke einfach auf den grauen Kopfbereich einer Mannschaft, um die Spielerliste ein- oder auszuklappen. Das sorgt für maximale Übersicht.
        </p>
        <h4>Wurfscheine drucken:</h4>
        <p>
          Im <strong>Startplan</strong> findest du in jeder Zeit-Zeile ein kleines Druck-Icon 🖨️. Ein Klick darauf generiert ein perfektes A4-PDF mit zwei Wurfscheinen pro Seite – einen für Bahn 1 & 2 und einen für Bahn 3 & 4. Ideal für die manuelle Erfassung am Spieltag. Über die Checkboxen oben kannst du steuern, ob Spielernamen oder Unterschriftenfelder gedruckt werden sollen.
        </p>
      </div>
    </div>
  );
};

export default HelpScreen;